export const LOADING = {
  NONE: 'NONE',
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
};

export const IDLES = [LOADING.NONE, LOADING.FINISHED];
